import React, { useState } from 'react';
import TemplateEditor from './TemplateEditor';

const TABS = [
  { id: 'editor',   label: 'Template Editor' },
  { id: 'generate', label: 'Generate Images' },
  { id: 'manage',   label: 'Manage Templates' },
];

class ErrorBoundary extends React.Component {
  constructor(p) { super(p); this.state = { error: null }; }
  static getDerivedStateFromError(e) { return { error: e }; }
  componentDidCatch(error, info) { console.error('PromoImageGenerator error:', error, info); }
  render() {
    if (this.state.error) {
      return (
        <div style={{ padding: 40, textAlign: 'center' }}>
          <div style={{ fontSize: 16, color: '#d32f2f', marginBottom: 12 }}>Something went wrong.</div>
          <div style={{ fontSize: 13, color: '#666', marginBottom: 16 }}>{this.state.error.message}</div>
          <button onClick={() => this.setState({ error: null })} style={{ padding: '8px 24px', background: '#1976d2', color: '#fff', border: 0, borderRadius: 4, cursor: 'pointer' }}>Try Again</button>
        </div>
      );
    }
    return this.props.children;
  }
}

function Placeholder({ title }) {
  return (
    <div style={{ flex: 1, display: 'flex', alignItems: 'center', justifyContent: 'center', color: '#6b7280', fontSize: 14 }}>
      {title} — coming soon
    </div>
  );
}

export default function PromoImageGenerator({ onDirtyChange }) {
  const [tab, setTab] = useState('editor');
  const [dirty, setDirty] = useState(false);

  // Forward dirty state up to the FavoritesDesigner shell so its tab guard
  // + beforeunload handler cover the promo editor too.
  React.useEffect(() => { onDirtyChange && onDirtyChange(dirty); }, [dirty, onDirtyChange]);

  // Guard internal tab changes (Editor → Generate/Manage) with an unsaved-
  // changes prompt, mirroring the FavoritesDesigner-level guard.
  const switchTab = (nextTab) => {
    if (nextTab === tab) return;
    if (dirty && !window.confirm('You have unsaved changes in the Template Editor. If you leave, your changes will be lost.')) {
      return;
    }
    // The confirmed switch leaves the editor, so those changes are discarded --
    // clear the flag, otherwise it stays stuck true and every later tab switch
    // (and the beforeunload guard) keeps warning for the rest of the session.
    if (dirty) setDirty(false);
    setTab(nextTab);
  };

  return (
    <ErrorBoundary>
      <div style={{ flex: 1, display: 'flex', flexDirection: 'column', minHeight: 0 }}>
        <div style={{ display: 'flex', alignItems: 'center', borderBottom: '1px solid #e5e7eb', background: '#fff', padding: '10px 16px' }}>
          <div style={{ fontSize: 18, fontWeight: 700, marginRight: 24 }}>📸 School Photo Template Studio</div>
          <div style={{ marginLeft: 'auto', display: 'flex', gap: 18 }}>
            {TABS.map((t) => (
              <button
                key={t.id}
                onClick={() => switchTab(t.id)}
                style={{
                  background: 'none', border: 0, padding: '8px 4px', fontSize: 14,
                  fontWeight: tab === t.id ? 700 : 500,
                  color: tab === t.id ? '#0ea5e9' : '#4b5563',
                  borderBottom: tab === t.id ? '2px solid #0ea5e9' : '2px solid transparent',
                  cursor: 'pointer',
                }}
              >{t.label}</button>
            ))}
          </div>
        </div>
        {tab === 'editor'   && <TemplateEditor onDirtyChange={setDirty} />}
        {tab === 'generate' && <Placeholder title="Generate Images" />}
        {tab === 'manage'   && <Placeholder title="Manage Templates" />}
      </div>
    </ErrorBoundary>
  );
}
